module.exports = __webpack_public_path__ + "static/fondo-movil-663ee2db5d857742ed46505645973235.jpeg";